import HeroPage from "./components/HeroPage";
import MessagingPage from "./components/MessagingPage";
import ContactPage from "./components/ContactPage";
import RemoteAccessPage from "./components/RemoteAccessPage";
import LegalPage from "./components/LegalPage";
import MySpacePage from "./components/MySpacePage";
import TicketingPage from "./components/TicketingPage";
import AboutPage from "./components/AboutPage";
import PricingPage from "./components/PricingPage";

function normalizePath(pathname) {
  if (!pathname || pathname === "/index.html") return "/";
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

function App() {
  const path = normalizePath(window.location.pathname);

  switch (path) {
    case "/":
      return <HeroPage />;
    case "/connect":
      return <MessagingPage />;
    case "/desk":
      return <TicketingPage />;
    case "/assist":
      return <RemoteAccessPage />;
    case "/about-us":
      return <AboutPage />;
    case "/pricing":
      return <PricingPage />;
    case "/contact-us":
      return <ContactPage />;
    case "/privacy-policy":
      return <LegalPage type="privacy" />;
    case "/terms-and-conditions":
      return <LegalPage type="terms" />;
    case "/my-space":
      return <MySpacePage />;
    default:
      return <HeroPage />;
  }
}

export default App;
